/**
 * The backend's ad format ids, their labels, and the two subsets a publisher screen offers.
 *
 * `adTypeLabel(id)` for a value off a record. For a form or a filter take a list —
 * `PUBLISHER_AD_TYPE_IDS`, `SELLABLE_AD_TYPE_IDS` or `PUBLISHER_AD_TYPE_OPTIONS` — rather
 * than every member of the enum: several formats exist for the demand side only, and
 * offering one of those means offering something that cannot be sold.
 */
export enum AdType {
  Banner = 1,
  Popunder = 2,
  Im = 4,
  Skim = 5,
  Overlay = 6,
  NativePush = 7,
  Slider = 8,
  Interstitial = 9,
  InpagePush = 10,
  OutStream = 11,
  Tab = 12
}

export const AdTypeLabels = {
  [AdType.Banner]: 'Banner',
  [AdType.Popunder]: 'Popunder',
  [AdType.Im]: 'IM',
  [AdType.Skim]: 'Direct Link',
  [AdType.Overlay]: 'In-video',
  [AdType.NativePush]: 'Native Push',
  [AdType.Slider]: 'Slider',
  [AdType.Interstitial]: 'Interstitial',
  [AdType.InpagePush]: 'In-Page Push',
  [AdType.OutStream]: 'OutStream',
  [AdType.Tab]: 'Tab'
} as const

export function adTypeLabel(typeId: number): string {
  return AdTypeLabels[typeId as AdType] ?? String(typeId)
}

export const PUBLISHER_AD_TYPE_IDS = [
  AdType.Popunder,
  AdType.Banner,
  AdType.Overlay,
  AdType.Slider,
  AdType.InpagePush,
  AdType.Interstitial,
  AdType.OutStream,
  AdType.Skim
] as const

export const SELLABLE_AD_TYPE_IDS = [
  ...PUBLISHER_AD_TYPE_IDS,
  AdType.Tab
] as const

/**
 * The same list as `Select` options with **string** values, for a filter, whose value rides the
 * URL. Built by hand and not through `labelsToOptions`: this segment sits below
 * `@/shared/lib` and may not import it.
 */
export const PUBLISHER_AD_TYPE_OPTIONS = PUBLISHER_AD_TYPE_IDS.map((id) => ({
  value: String(id),
  label: AdTypeLabels[id]
}))
